var map = {
	"./chinatown/assets/mini-logo.png": "0196",
	"./dailypizza/assets/mini-logo.png": "f4fc",
	"./diyars/assets/mini-logo.png": "20b4",
	"./enjoy-food/assets/mini-logo.png": "8eda",
	"./mryu/assets/mini-logo.png": "d4d6",
	"./napolimania/assets/mini-logo.png": "a8be",
	"./ni-hao-kaiser/assets/mini-logo.png": "0dd3",
	"./pizzeria-no3/assets/mini-logo.png": "cb83",
	"./testrestaurant/assets/mini-logo.png": "52f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2c3";